exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-21b45bbe]{color:#0c2340;-webkit-transition:color .1s linear;transition:color .1s linear}a[data-v-21b45bbe]:hover{color:#061323}", ""]);

// exports
